import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12v-9","key":"svg-0"}],["path",{"d":"M12 12l-9 -2.5","key":"svg-1"}],["path",{"d":"M12 12l9 -2.5","key":"svg-2"}],["path",{"d":"M12 12l6 8.5","key":"svg-3"}],["path",{"d":"M12 12l-6 8.5","key":"svg-4"}]]

const IconAsteriskSimple = createReactComponent('outline', 'asterisk-simple', 'AsteriskSimple', __iconNode);

export default IconAsteriskSimple;